module.exports = __webpack_public_path__ + "img/ycc_rewards_1000.770a13e0.png";